import BoundaryLegendType from "../../enum/boundaryLegends/BoundaryLegendType";
import BoundaryType from "../../enum/BoundaryType";
import BoundaryLegend from "../../types/map/BoundaryLegend";

export const isTerritoryColorBoundaryLegend = (legend: BoundaryLegend) => {
  return (
    legend.type === BoundaryLegendType.RECORD &&
    legend.filters === null &&
    legend.entity === null &&
    legend.view === BoundaryType.TERRITORY
  );
};

export const isNothingBoundaryLegend = (legend: BoundaryLegend) => {
  return (
    legend.type === BoundaryLegendType.DEMOGRAPHIC &&
    legend.filters === null &&
    legend.country === null &&
    legend.view === BoundaryType.GEOGRAPHY
  );
};
